import { render, staticRenderFns } from "./SubscriptionBadge.vue?vue&type=template&id=c5f8f23a&scoped=true&"
import script from "./SubscriptionBadge.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBadge.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionBadge.vue?vue&type=style&index=0&id=c5f8f23a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f8f23a",
  null
  
)

export default component.exports